import React from 'react';
import { Grid, Typography, Box, Divider } from '@mui/material';
import ButtonGeneral from '../general/buttons/buttonGeneral';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GridPaginationModel } from '@mui/x-data-grid';
import { Table } from '../general/table';

type Props = {
    title?: string;
    titleButtonAdd?: string;
    startIconButtonAdd?: JSX.Element | string;
    onClickAdd?: any;
    onClickBack?: () => void;
    columns?: any;
    rows?: any;
    rowCount?: number;
    loading?: boolean;
    checkboxSelection?: boolean | false;
    paginationModel?: GridPaginationModel;
    setPaginationModel?: React.Dispatch<
        React.SetStateAction<GridPaginationModel>
    >;
    disableRow?: boolean | false;
    disableAdd?: boolean | false;
    enabledSearch?: boolean | false;
    searchField?: JSX.Element | string;
    disableDataGrid?: false | boolean;
    filterAvanced?: false | boolean;
    onFilterAvanced?: any;
    onClickRow?: (row: any) => void;
};

const ListView = ({
    title,
    titleButtonAdd,
    startIconButtonAdd,
    onClickAdd,
    onClickBack,
    columns,
    rows,
    rowCount,
    checkboxSelection,
    disableRow,
    disableAdd,
    disableDataGrid,
    paginationModel,
    setPaginationModel,
    loading,
    enabledSearch,
    searchField,
    filterAvanced,
    onFilterAvanced,
    onClickRow,
}: Props) => {
    const validateFilter = (newModel: any) => {
        if (newModel) {
            const data = newModel.items[0] || [];
            if (data?.value) {
                onFilterAvanced(data);
            } else {
                onFilterAvanced(null);
            }
        }
    };

    return (
        <Box sx={{ minWidth: 350 }} px={2}>
            {title && (
                <>
                    <Typography
                        component="h3"
                        px={1}
                        sx={{
                            flexGrow: 1,
                            color: 'primary.main',
                            fontSize: { lg: 24, md: 22, xs: 20 },
                        }}
                    >
                        {title}
                    </Typography>
                    <Divider />
                </>
            )}
            <Grid container mt={2}>
                {enabledSearch && (
                    <Grid item xs={12} sm={5} md={5} lg={5}>
                        {searchField}
                    </Grid>
                )}
                <Grid
                    item
                    xs={12}
                    sm={enabledSearch ? 7 : 12}
                    md={enabledSearch ? 7 : 12}
                    lg={enabledSearch ? 7 : 12}
                    sx={{
                        mt: {
                            xs: enabledSearch ? 2 : 0,
                            sm: 0,
                        },
                        textAlign: 'right',
                    }}
                >
                    {disableAdd !== true ? (
                        <ButtonGeneral
                            onClick={onClickAdd}
                            startIcon={startIconButtonAdd || undefined}
                            title={titleButtonAdd || ''}
                            sx={{
                                mr: 1,
                                mt: { xs: 1, md: 0 },
                                backgroundColor: 'primary.main',
                            }}
                        />
                    ) : null}
                    {onClickBack && (
                        <ButtonGeneral
                            onClick={onClickBack}
                            startIcon={
                                <ArrowBackIcon
                                    sx={{ color: 'primary.contrastText' }}
                                />
                            }
                            title="Volver"
                            sx={{
                                fontSize: { lg: 12, md: 10.5, xs: 9 },
                                mt: { xs: disableAdd !== true && 1, md: 0 },
                                mr: { xs: disableAdd !== true && 1, md: 0 },
                                backgroundColor: 'primary.main',
                            }}
                        />
                    )}
                </Grid>
            </Grid>
            {!disableDataGrid ? (
                <Table
                    rows={rows}
                    columns={columns}
                    paginationModel={paginationModel}
                    rowCount={rowCount}
                    loading={loading}
                    onFilterModelChange={(newModel: any) =>
                        filterAvanced && validateFilter(newModel)
                    }
                    onPaginationModelChange={setPaginationModel}
                    checkboxSelection={checkboxSelection}
                    disableRowSelectionOnClick={disableRow}
                    onRowClick={(item) => onClickRow && onClickRow(item.row)}
                />
            ) : null}
        </Box>
    );
};

export default ListView;
